module.exports = __webpack_public_path__ + "static/media/jzcard.d414764d.png";